module.exports = __webpack_public_path__ + "img/svg.617b5f96.png";